var _defs, _path, _path2, _path3, _path4, _path5, _g, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrunkrsLoaderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trunkrs-logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 180.992,
    height: 21,
    viewBox: "0 0 180.992 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #201047;\n      }\n\n      .cls-3 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-4 {\n        fill: #00d163;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_7",
    "data-name": "Clip 7",
    className: "cls-1",
    d: "M0,0H178.951V19.912H0Z",
    transform: "translate(0)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    className: "cls-2",
    d: "M13.58,2.8V20H9.421V2.8H0L.107,0H22.929L23,2.8H13.58",
    transform: "translate(37.992 1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    "data-name": "Fill 2",
    className: "cls-2",
    d: "M0,15V.348L3.1.2l.184,1.368.185,2.015h.074C5.134,1.343,7.9,0,11.451,0A14.835,14.835,0,0,1,14,.224l-.222,2.562a12.5,12.5,0,0,0-2.586-.249c-4.1,0-7.277,2.114-7.277,5.348V15H0",
    transform: "translate(59.992 6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    "data-name": "Fill 3",
    className: "cls-2",
    d: "M19,9.48C19,12.9,15.921,15,9.483,15,3.079,15,0,12.871,0,9.48V0H3.709V9.381c0,2.054,1.89,3.292,5.774,3.292s5.808-1.213,5.808-3.292V0H19V9.48",
    transform: "translate(75.992 6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    className: "cls-2",
    d: "M15.291,15V5.876c0-2.43-1.995-3.521-5.739-3.521-2.065,0-4.619.645-5.844,1.81V15H0V.347L2.589.2l.7,1.711A13.605,13.605,0,0,1,10.532,0C15.816,0,19,2.008,19,5.876V15H15.291",
    transform: "translate(99.992 6)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_5",
    "data-name": "Fill 5",
    className: "cls-2",
    d: "M3.571,11.39H7.31L14.317,5.23h4.345l-8.354,7.221L19,21H14.654L7.277,13.7H3.571V21H0V.159L3.571,0V11.39",
    transform: "translate(124.992)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0 1.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_7-2",
    "data-name": "Clip 7",
    className: "cls-1",
    d: "M0,0H178.951V19.912H0Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11-2",
    "data-name": "Group 11",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    className: "cls-2",
    d: "M0,15.742V.365L2.937.209l.175,1.436.175,2.115h.07A8.5,8.5,0,0,1,10.838,0a12.709,12.709,0,0,1,2.413.235l-.21,2.689a10.719,10.719,0,0,0-2.448-.261c-3.88,0-6.887,2.219-6.887,5.613v7.466H0",
    transform: "translate(147.031 3.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_8",
    "data-name": "Fill 8",
    className: "cls-2",
    d: "M7.657,16.108A17.765,17.765,0,0,1,0,14.62l.525-2.3a16.505,16.505,0,0,0,7.168,1.54c3.531,0,4.964-1.149,4.964-2.454C12.657,8.015.035,9.816.035,4.438.035,1.775,2.868,0,8.461,0a22.306,22.306,0,0,1,6.713.966l-.35,2.245a23.878,23.878,0,0,0-6.5-.94c-2.9,0-4.721.809-4.721,2.036,0,3.159,12.516,1.331,12.516,6.814,0,2.82-2.482,4.986-8.46,4.986",
    transform: "translate(162.833 3.812)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_9",
    "data-name": "Fill 9",
    className: "cls-4",
    d: "M.185,5.965a.544.544,0,0,0,.379.949L10.7,6.887a.909.909,0,0,0,.6-.226L18.85,0,7.683.03A2.041,2.041,0,0,0,6.337.537L.185,5.965",
    transform: "translate(-0.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_10",
    "data-name": "Fill 10",
    className: "cls-2",
    d: "M33.253,0l-12.2.028a1.047,1.047,0,0,0-.688.258L13.136,6.641a.821.821,0,0,0-.28.615v4.906a.527.527,0,0,1-.534.519l-4.666.011a1.972,1.972,0,0,0-1.3.49L.185,18.627a.544.544,0,0,0,.379.949l12.009-.028a.748.748,0,0,0,.492-.185l7.315-6.428a.821.821,0,0,0,.28-.615V7.416a.527.527,0,0,1,.534-.519l5-.012a1.079,1.079,0,0,0,.711-.268L33.554.753a.431.431,0,0,0-.3-.753",
    transform: "translate(-0.008 0.003)"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_12",
    "data-name": "Fill 12",
    className: "cls-5",
    d: "M1,2A1,1,0,1,1,1,0,.985.985,0,0,1,2,.994.991.991,0,0,1,1,2ZM1,.2A.766.766,0,0,0,.249.994a.76.76,0,0,0,.76.794A.757.757,0,0,0,1.751,1,.758.758,0,0,0,1,.2ZM.848,1.517H.623V.521A1.92,1.92,0,0,1,1,.491a.6.6,0,0,1,.338.073A.282.282,0,0,1,1.43.782a.252.252,0,0,1-.2.23v.013a.292.292,0,0,1,.177.242.78.78,0,0,0,.071.248l-.243,0a.54.54,0,0,1-.059-.171l-.019-.072c-.017-.11-.078-.158-.2-.158H.848v.4ZM.979.654A.478.478,0,0,0,.855.667V.951H.96C1.1.951,1.187.9,1.187.806S1.113.654.979.654Z",
    transform: "translate(178.992 3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrunkrsLoaderIcon);
export default __webpack_public_path__ + "static/media/trunkrs-loader-icon.fcf52e802f55ef83cb858d33737e558a.svg";
export { ForwardRef as ReactComponent };